module.exports = __webpack_public_path__ + "img/PerfectStaff.ef4ae9be.png";